import { render, staticRenderFns } from "./editarPendientes.vue?vue&type=template&id=0762a901&"
import script from "./editarPendientes.vue?vue&type=script&lang=js&"
export * from "./editarPendientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports